<template>
    <span class="px-2 py-1 text-xs font-medium rounded-full whitespace-nowrap" :class="style.classes">
        {{ style.label }}
    </span>
</template>

<script>
const STYLES = {
    pending: {label: 'En attente', classes: 'bg-gray-100 text-gray-700'},
    running: {label: 'En cours', classes: 'bg-blue-100 text-blue-700'},
    succeeded: {label: 'Terminé', classes: 'bg-green-100 text-green-700'},
    failed: {label: 'Échec', classes: 'bg-red-100 text-red-700'},
};

export default {
    props: {
        status: String,
    },
    computed: {
        style() {
            return STYLES[this.status] || STYLES.pending;
        },
    },
}
</script>
